import { DATE_FORMATS } from '$gbusiness/enums';
import CellModel from '$gbusiness/models/cell';
import { format } from '$gbusiness/helpers/date';
import { INVOICE_PAYMENTS } from '$fbusiness/enums/options/paymentType';
//import mockData from '$business/mocks/getInvoices.json';

import { currency } from '$gbusiness/helpers/util';
import intl from '$intl';
import { Edit } from '@mui/icons-material';
import { Flex } from '$gstyles/wrapper';
import { displayPaymentInfo } from './utils';
import { PAYMENT_TYPE } from '$fbusiness/enums/options/paymentType';
import { Link } from '$gstyles/general';
import { accessHide } from '$fbusiness/helpers/util';

const derivePaymentType = (row) => {
  if (row.creditType) {
    if (row.isSourceInvoice) return 'Refund';
    return 'Store Credit';
  }
  return (
    <div className={row.isRefund ? 'uppercase' : ''}>
      {!row.type
        ? ''
        : row.isRc
        ? `REFUND CREDIT #RC${row.id}`
        : row?.amount >= 0
        ? intl('INPUT.OPTION.PAYMENT_TYPE.' + row.type)
        : intl('COMMON.DISCOUNT')}
    </div>
  );
};

export const INVOICE_PAYMENTS_TABLE_MIN = ({
  onReject = null,
  onClickOriginal = null,
  ACCESS,
}: any): Array<CellModel> => [
  {
    label: 'SCREEN.INVOICE_PAYMENT.COLS.PAYMENT_TYPE',
    value: 'amount',
    alwaysShow: true,
    component: (row) => derivePaymentType(row),
    className: 'main',
    width: 200,
  },
  {
    label: 'SCREEN.INVOICE_PAYMENT.COLS.DATE',
    value: 'paymentDate',
    component: (row) => <>{format(row.paymentDate, DATE_FORMATS.SLASH)}</>,
    alwaysShow: true,
    width: 200,
  },
  {
    label: 'SCREEN.INVOICE_PAYMENT.COLS.ORIGINAL',
    value: 'original',
    className: accessHide(ACCESS.MONEY.VIEW),
    component: (row) => (
      <span
      // className={onClickOriginal && 'link'}
      // onClick={() => onClickOriginal && onClickOriginal(row)}
      >
        {row.originalAmount === null ? '' : currency(row.originalAmount)}
      </span>
    ),
    alwaysShow: true,
    width: 170,
  },
  {
    label: 'SCREEN.INVOICE_PAYMENT.COLS.AMOUNT',
    value: 'amount',
    className: accessHide(ACCESS.MONEY.VIEW),
    component: (row) => (
      <span className={`${row.type === INVOICE_PAYMENTS.DISCOUNT && 'successHold outlined'}`}>
        {currency(row.amount * ((row.isRefund && !row.isRc) || row.isSourceInvoice ? 1 : -1))}
      </span>
    ),
    alwaysShow: true,
    width: 150,
  },
  {
    label: 'SCREEN.INVOICE_PAYMENT.COLS.INFO',
    value: 'amount',
    component: displayPaymentInfo,
    alwaysShow: true,
    width: 300,
  },
  {
    isHidden: !onReject,
    label: '',
    value: 'reject',
    component: (row) => {
      if (row.rejected) return <>Rejected</>;
      const rejectTypes = [PAYMENT_TYPE.ACH, PAYMENT_TYPE.CHECK, PAYMENT_TYPE.CASH, PAYMENT_TYPE.OTHER];
      if (!rejectTypes.includes(row.type)) return null;

      return <Link onClick={() => onReject(row)}>{intl('REJECT')}</Link>;
    },
    width: 80,
  },
];

export const INNER_PAYMENTS_TABLE = ({ onEditPayment, ACCESS }): Array<CellModel> => [
  ...INVOICE_PAYMENTS_TABLE_MIN({ ACCESS }),
  {
    label: '',
    value: '',
    component: (row) => <>{row.rejectedAt ? 'Rejected' : ''}</>,
    width: 80,
  },
  {
    label: '',
    value: '',
    className: 'action',
    component: (row, actions, i) => (
      <div style={{ width: '100%' }}>
        {!row.rejectedAt && (
          <Flex justifyContent="flex-end">
            {row.id > 0 && row.type !== INVOICE_PAYMENTS.CREDITS && (
              <Edit onClick={() => onEditPayment(row, i)} className="pointer small" />
            )}
            {/* <Delete onClick={() => onDeletePayment(row, i)} className="pointer small" /> */}
          </Flex>
        )}
      </div>
    ),
    minWidth: 60,
    width: 60,
  },
];
